// extracted by mini-css-extract-plugin
export default {"job":"SpeakerCard_job__qLqJ4","company":"SpeakerCard_company__bv-Na","wrapper":"SpeakerCard_wrapper__LmaNn"};